import { useTranslation } from 'react-i18next';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';
import useIsMobile from '@/hooks/useIsMobile';

const CourseSystem = () => {
  const { t, i18n } = useTranslation(['home', 'english']);
  const isMobile = useIsMobile();
  let imgUrl = `/images/english/data_${i18n.language || 'en'}.png`;
  if (isMobile) {
    imgUrl = `/images/english/data_m_${i18n.language || 'en'}.png`;
  }
  return (
    <div className="container mt-[5rem] lg:mt-[140px] xl:mt-[200px]">
      <Title className="mb-[24px]" innerHTML theme="english">
        {t('english:课程体系-标题')}
      </Title>
      <p className="mb-[1.5rem] text-center text-base font-normal !leading-normal text-wk-words-1 lg:mb-[48px] lg:text-base xl:mb-[60px] xl:text-[20px]">
        {t('english:课程体系-副标题')}
      </p>
      <div>
        <img
          src={imgUrl}
          alt={t('english:seo-悟空高级英文阅读与写作课程体系')}
          className="w-full"
        />
      </div>
      <div className="mt-[1.5rem] text-center lg:mt-[60px] xl:mt-[60px]">
        <LeadButton
          subject="english"
          theme="english"
          size="xl"
          traceName="O_EnglishCourse_SevenSteps_CTAClick"
          traceGa4Name="new_entry_EnglishCourse_SevenStepsCTA">
          {t('english:立即体验')}
        </LeadButton>
      </div>
    </div>
  );
};

export default CourseSystem;
